import React, {Component} from "react";
import msparcs from "assets/img/msparcs.png";
import $ from 'jquery';


import {Nav, NavItem, Tab, Table} from 'react-bootstrap';
import {DropdownButton, MenuItem} from 'react-bootstrap';


import ColumnChart from 'components/amcharts/ColumnChart';
import LineChart from 'components/amcharts/LineChart';
import PieChart from 'components/amcharts/PieChart';
import StackedColumnChart from 'components/amcharts/StackedColumnChart';
import AreaChart from 'components/amcharts/AreaChart';
import BubbleChart from 'components/amcharts/BubbleChart';
import BarChart from 'components/amcharts/BarChart';


import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';

class MyComponent {
    render() {
        return (
            <DateRangePicker startDate="1/1/2014" endDate="3/1/2014">
                <button>Click Me To Open Picker!</button>
            </DateRangePicker>
        );
    }
}

class AcqurierDashboard extends Component {
    state = {
        data: [],
        chartHeight: "250px"
    };

    componentWillMount() {

        let SalesData = [{
            "country": "USA",
            "visits": 2025
        }, {
            "country": "China",
            "visits": 1882
        }, {
            "country": "Japan",
            "visits": 1809
        }, {
            "country": "Germany",
            "visits": 1322
        }, {
            "country": "UK",
            "visits": 1122
        }, {
            "country": "France",
            "visits": 1114
        }, {
            "country": "India",
            "visits": 984
        }, {
            "country": "Spain",
            "visits": 711
        }, {
            "country": "Netherlands",
            "visits": 665
        }, {
            "country": "Russia",
            "visits": 580
        }, {
            "country": "South Korea",
            "visits": 443
        }, {
            "country": "Canada",
            "visits": 441
        }, {
            "country": "Brazil",
            "visits": 395
        }];

        this.setState({
            data: SalesData,
            chartHeight: "250px"
        });
    }

    render() {
        return (
            <div className="content">
                <div className="container-fluid  p-t-5">
                    <div className="row">
                        <div className="col-lg-6 col-sm-12 col-xs-12">
                            <Table striped>
                                <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Innoviti Base</th>
                                    <th>Acquiring Bank</th>
                                    <th className="text-right">%</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>Total Store Count</td>
                                    <td className="text-right">29,459</td>
                                    <td className="text-right">19,025</td>
                                    <td className="text-right">64.58</td>
                                </tr>
                                <tr>
                                    <td>Total Transction volume(Cr, ₹)</td>
                                    <td className="text-right">29,459</td>
                                    <td className="text-right">127.03</td>
                                    <td className="text-right">88.08</td>
                                </tr>
                                <tr>
                                    <td>Total Credit card volume(Cr, ₹)</td>
                                    <td className="text-right">62.93</td>
                                    <td className="text-right">44.00</td>
                                    <td className="text-right">69.93</td>
                                </tr>
                                <tr>
                                    <td>Total Debit card volume(Cr, ₹)</td>
                                    <td className="text-right">62.94</td>
                                    <td className="text-right">50.54</td>
                                    <td className="text-right">64.58</td>
                                </tr>
                                <tr>
                                    <td>UPI volume(Cr, ₹)</td>
                                    <td className="text-right">1.10</td>
                                    <td className="text-right">0.00</td>
                                    <td className="text-right">0.00</td>
                                </tr>
                                <tr>
                                    <td>EMI Transaction Volume(Cr, ₹)</td>
                                    <td className="text-right">0.08</td>
                                    <td className="text-right">0.04</td>
                                    <td className="text-right">50</td>
                                </tr>
                                <tr>
                                    <td>DCC Transaction Volume(Cr, ₹)</td>
                                    <td className="text-right">0.08</td>
                                    <td className="text-right">0.04</td>
                                    <td className="text-right">50</td>
                                </tr>

                                </tbody>
                            </Table>
                        </div>
                        <div className="col-lg-3 col-sm-6 col-xs-12">
                            <div className="form-group">
                                <label className="d-block">
                                    Acquiring Bank
                                </label>
                                <DropdownButton title="Default" key="1" id={`dropdown-basic-1`}
                                                className="form-control w-100">
                                    <MenuItem eventKey="1">Action</MenuItem>
                                    <MenuItem eventKey="2">Another action</MenuItem>
                                    <MenuItem eventKey="3">Something else here</MenuItem>
                                    <MenuItem divider/>
                                    <MenuItem eventKey="4">Separated link</MenuItem>
                                    <MenuItem divider/>
                                    <MenuItem eventKey="5">One more separated link</MenuItem>
                                </DropdownButton>
                            </div>
                            <div className="card p-5 text-center">
                                <small>
                                    BTIDs configured
                                    <br/>
                                    (with Innoviti)
                                </small>
                                <h3 className="m-0">
                                    <strong>
                                        105,352
                                    </strong>
                                </h3>
                                <small>
                                    <i className="fa fa-long-arrow-up text-success" aria-hidden="true"></i> vs Jan 2020
                                </small>
                            </div>
                        </div>
                        <div className="col-lg-3 col-sm-6 col-xs-12">
                            <div className="form-group">
                                <label className="d-block">
                                    Date Filter
                                </label>
                                <DateRangePicker>
                                    <button className="btn btn-default form-control">
                                        Select Date
                                    </button>
                                </DateRangePicker>
                            </div>
                            <div className="card p-5 text-center">
                                <small>
                                    % Successful transaction
                                    <br/>
                                    with Bank as acquirer
                                </small>
                                <h3 className="m-0">
                                    <strong>
                                        95.45%
                                    </strong>
                                </h3>
                                <small>
                                    <i className="fa fa-long-arrow-up text-success" aria-hidden="true"></i> 0.6% vs
                                    yesterday
                                </small>
                            </div>
                        </div>
                    </div>

                    <div className="row m-0">
                        <Tab.Container id="nav-with-icons" defaultActiveKey="volume">
                            <div>
                                <div className="nav-container">
                                    <Nav bsStyle="tabs" bsclassName="nav nav-icons">
                                        <NavItem eventKey="volume">
                                            Volume
                                        </NavItem>
                                        <NavItem eventKey="count">
                                            Count
                                        </NavItem>
                                    </Nav>
                                </div>
                                <Tab.Content className="tab-content-style">
                                    <Tab.Pane eventKey="volume" className="row">
                                        <div className="col-md-6 col-sm-6 col-xs-12">
                                            <div className="card">
                                                <div className="header">
                                                    <h4 className="title">Merchants</h4>
                                                    {/*<p className="category">24 Hours performance</p>*/}
                                                </div>
                                                <div className="ChartContent">
                                                    <LineChart data={this.state.data}  chartHeight={this.state.chartHeight}/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6 col-sm-6 col-xs-12">
                                            <div className="card">
                                                <div className="header">
                                                    <h4 className="title">Total transaction volume (Cr, ₹)</h4>
                                                    {/*<p className="category">24 Hours performance</p>*/}
                                                </div>
                                                <div className="ChartContent">
                                                    <LineChart data={this.state.data}
                                                               chartHeight={this.state.chartHeight}/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6 col-sm-6 col-xs-12">
                                            <div className="card">
                                                <div className="header">
                                                    <h4 className="title">Total Card Volume (Cr, ₹)</h4>
                                                    {/*<p className="category">24 Hours performance</p>*/}
                                                </div>
                                                <div className="ChartContent">
                                                    <LineChart data={this.state.data}
                                                               chartHeight={this.state.chartHeight}/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6 col-sm-6 col-xs-12">
                                            <div className="card">
                                                <div className="header">
                                                    <h4 className="title">EMI Transaction Volume (Cr, ₹)</h4>
                                                    {/*<p className="category">24 Hours performance</p>*/}
                                                </div>
                                                <div className="ChartContent">
                                                    <LineChart data={this.state.data}
                                                               chartHeight={this.state.chartHeight}/>
                                                </div>
                                            </div>
                                        </div>

                                    </Tab.Pane>
                                    <Tab.Pane eventKey="count" className="row">
                                        <div className="col-md-6 col-sm-6 col-xs-12">
                                            <div className="card">
                                                <div className="header">
                                                    <h4 className="title">Merchants</h4>
                                                    {/*<p className="category">24 Hours performance</p>*/}
                                                </div>
                                                <div className="ChartContent">
                                                    <LineChart data={this.state.data}
                                                               chartHeight={this.state.chartHeight}/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6 col-sm-6 col-xs-12">
                                            <div className="card">
                                                <div className="header">
                                                    <h4 className="title">Total transaction Count (Cr, ₹)</h4>
                                                    {/*<p className="category">24 Hours performance</p>*/}
                                                </div>
                                                <div className="ChartContent">
                                                    <LineChart data={this.state.data}
                                                               chartHeight={this.state.chartHeight}/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6 col-sm-6 col-xs-12">
                                            <div className="card">
                                                <div className="header">
                                                    <h4 className="title">Total Card Count (Cr, ₹)</h4>
                                                    {/*<p className="category">24 Hours performance</p>*/}
                                                </div>
                                                <div className="ChartContent">
                                                    <LineChart data={this.state.data}
                                                               chartHeight={this.state.chartHeight}/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6 col-sm-6 col-xs-12">
                                            <div className="card">
                                                <div className="header">
                                                    <h4 className="title">EMI Transaction Count (Cr, ₹)</h4>
                                                    {/*<p className="category">24 Hours performance</p>*/}
                                                </div>
                                                <div className="ChartContent">
                                                    <LineChart data={this.state.data}
                                                               chartHeight={this.state.chartHeight}/>
                                                </div>
                                            </div>
                                        </div>
                                    </Tab.Pane>

                                </Tab.Content>
                            </div>
                        </Tab.Container>
                    </div>
                    <div className="row">
                        <div className="col-md-4 col-xs-12">
                            <div className="card">
                                <div className="header">
                                    <h4 className="title">Transaction <br/> Routing and Success Rate [count]</h4>
                                    {/*<p className="category">24 Hours performance</p>*/}
                                </div>
                                <div className="ChartContent">
                                    <LineChart data={this.state.data} chartHeight={this.state.chartHeight}/>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 col-xs-12">
                            <div className="card">
                                <div className="header">
                                    <h4 className="title">EMI Transaction <br/> Split by Tenor</h4>
                                    {/*<p className="category">24 Hours performance</p>*/}
                                </div>
                                <div className="ChartContent">
                                    <LineChart data={this.state.data} chartHeight={this.state.chartHeight}/>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 col-xs-12">
                            <div className="card">
                                <div className="header">
                                    <h4 className="title">Transaction <br/> by Tender mode (lakhs, ₹)
                                    </h4>
                                    {/*<p className="category">24 Hours performance</p>*/}
                                </div>
                                <div className="ChartContent">
                                    <PieChart data={this.state.data}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row m-0">
                        <Tab.Container id="nav-with-icons" defaultActiveKey="volume">
                            <div>
                                <div className="nav-container">
                                    <Nav bsStyle="tabs" bsclassName="nav nav-icons">
                                        <NavItem eventKey="volume">
                                            Acquiring Bank Present
                                        </NavItem>
                                        <NavItem eventKey="count">
                                            Acquiring Bank Absent
                                        </NavItem>
                                    </Nav>
                                </div>
                                <Tab.Content>
                                    <Tab.Pane eventKey="volume">
                                        <Table striped>
                                            <thead>
                                            <tr>
                                                <th rowSpan="2">Merchant</th>
                                                <th rowSpan="2">Region</th>
                                                <th rowSpan="2">City</th>
                                                <th colSpan="2">Store Count</th>
                                                <th colSpan="2">Terminal Count</th>
                                                <th colSpan="2">Card Volume</th>
                                                <th colSpan="2">UPI Volume</th>
                                                <th colSpan="2">EMI Volume</th>
                                            </tr>
                                            <tr>
                                                <th>Region</th>
                                                <th>City</th>
                                                <th>Innoviti</th>
                                                <th>Bank</th>
                                                <th>Innoviti</th>
                                                <th>Bank</th>
                                                <th>Innoviti</th>
                                                <th>Bank</th>
                                                <th>Innoviti</th>
                                                <th>Bank</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td>Arvind Lifestyle Brands Ltd</td>
                                                <td></td>
                                                <td></td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>3062965</td>
                                                <td>3003978</td>
                                                <td>0</td>
                                                <td>0</td>
                                                <td>50000</td>
                                                <td>50000</td>
                                            </tr>
                                            <tr>
                                                <td>Aakash Educational Services</td>
                                                <td></td>
                                                <td></td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>3062965</td>
                                                <td>3003978</td>
                                                <td>0</td>
                                                <td>0</td>
                                                <td>50000</td>
                                                <td>50000</td>
                                            </tr>
                                            <tr>
                                                <td>Aditya Birla Retail Limited</td>
                                                <td></td>
                                                <td></td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>3062965</td>
                                                <td>3003978</td>
                                                <td>0</td>
                                                <td>0</td>
                                                <td>50000</td>
                                                <td>50000</td>
                                            </tr>
                                            <tr>
                                                <td>Adyar Departmental Stores</td>
                                                <td></td>
                                                <td></td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>3062965</td>
                                                <td>3003978</td>
                                                <td>0</td>
                                                <td>0</td>
                                                <td>50000</td>
                                                <td>50000</td>
                                            </tr>
                                            <tr>
                                                <td>Arvind Lifestyle Brands Ltd</td>
                                                <td></td>
                                                <td></td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>3062965</td>
                                                <td>3003978</td>
                                                <td>0</td>
                                                <td>0</td>
                                                <td>50000</td>
                                                <td>50000</td>
                                            </tr>
                                            <tr>
                                                <td>Aakash Educational Services</td>
                                                <td></td>
                                                <td></td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>3062965</td>
                                                <td>3003978</td>
                                                <td>0</td>
                                                <td>0</td>
                                                <td>50000</td>
                                                <td>50000</td>
                                            </tr>
                                            <tr>
                                                <td>Aditya Birla Retail Limited</td>
                                                <td></td>
                                                <td></td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>3062965</td>
                                                <td>3003978</td>
                                                <td>0</td>
                                                <td>0</td>
                                                <td>50000</td>
                                                <td>50000</td>
                                            </tr>
                                            <tr>
                                                <td>Adyar Departmental Stores</td>
                                                <td></td>
                                                <td></td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>3062965</td>
                                                <td>3003978</td>
                                                <td>0</td>
                                                <td>0</td>
                                                <td>50000</td>
                                                <td>50000</td>
                                            </tr>
                                            <tr>
                                                <td>Arvind Lifestyle Brands Ltd</td>
                                                <td></td>
                                                <td></td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>3062965</td>
                                                <td>3003978</td>
                                                <td>0</td>
                                                <td>0</td>
                                                <td>50000</td>
                                                <td>50000</td>
                                            </tr>
                                            <tr>
                                                <td>Aakash Educational Services</td>
                                                <td></td>
                                                <td></td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>3062965</td>
                                                <td>3003978</td>
                                                <td>0</td>
                                                <td>0</td>
                                                <td>50000</td>
                                                <td>50000</td>
                                            </tr>
                                            <tr>
                                                <td>Aditya Birla Retail Limited</td>
                                                <td></td>
                                                <td></td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>3062965</td>
                                                <td>3003978</td>
                                                <td>0</td>
                                                <td>0</td>
                                                <td>50000</td>
                                                <td>50000</td>
                                            </tr>
                                            <tr>
                                                <td>Adyar Departmental Stores</td>
                                                <td></td>
                                                <td></td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>3062965</td>
                                                <td>3003978</td>
                                                <td>0</td>
                                                <td>0</td>
                                                <td>50000</td>
                                                <td>50000</td>
                                            </tr>
                                            <tr>
                                                <td>Arvind Lifestyle Brands Ltd</td>
                                                <td></td>
                                                <td></td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>3062965</td>
                                                <td>3003978</td>
                                                <td>0</td>
                                                <td>0</td>
                                                <td>50000</td>
                                                <td>50000</td>
                                            </tr>
                                            <tr>
                                                <td>Aakash Educational Services</td>
                                                <td></td>
                                                <td></td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>3062965</td>
                                                <td>3003978</td>
                                                <td>0</td>
                                                <td>0</td>
                                                <td>50000</td>
                                                <td>50000</td>
                                            </tr>
                                            <tr>
                                                <td>Aditya Birla Retail Limited</td>
                                                <td></td>
                                                <td></td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>3062965</td>
                                                <td>3003978</td>
                                                <td>0</td>
                                                <td>0</td>
                                                <td>50000</td>
                                                <td>50000</td>
                                            </tr>
                                            <tr>
                                                <td>Adyar Departmental Stores</td>
                                                <td></td>
                                                <td></td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>3062965</td>
                                                <td>3003978</td>
                                                <td>0</td>
                                                <td>0</td>
                                                <td>50000</td>
                                                <td>50000</td>
                                            </tr>
                                            </tbody>
                                        </Table>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="count">
                                        <Table striped>
                                            <thead>
                                            <tr>
                                                <th rowSpan="2">Merchant</th>
                                                <th rowSpan="2">Region</th>
                                                <th rowSpan="2">City</th>
                                                <th colSpan="2">Store Count</th>
                                                <th colSpan="2">Terminal Count</th>
                                                <th colSpan="2">Card Volume</th>
                                                <th colSpan="2">UPI Volume</th>
                                                <th colSpan="2">EMI Volume</th>
                                            </tr>
                                            <tr>
                                                <th>Region</th>
                                                <th>City</th>
                                                <th>Innoviti</th>
                                                <th>Bank</th>
                                                <th>Innoviti</th>
                                                <th>Bank</th>
                                                <th>Innoviti</th>
                                                <th>Bank</th>
                                                <th>Innoviti</th>
                                                <th>Bank</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td>Arvind Lifestyle Brands Ltd</td>
                                                <td></td>
                                                <td></td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>3062965</td>
                                                <td>3003978</td>
                                                <td>0</td>
                                                <td>0</td>
                                                <td>50000</td>
                                                <td>50000</td>
                                            </tr>
                                            <tr>
                                                <td>Aakash Educational Services</td>
                                                <td></td>
                                                <td></td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>3062965</td>
                                                <td>3003978</td>
                                                <td>0</td>
                                                <td>0</td>
                                                <td>50000</td>
                                                <td>50000</td>
                                            </tr>
                                            <tr>
                                                <td>Aditya Birla Retail Limited</td>
                                                <td></td>
                                                <td></td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>3062965</td>
                                                <td>3003978</td>
                                                <td>0</td>
                                                <td>0</td>
                                                <td>50000</td>
                                                <td>50000</td>
                                            </tr>
                                            <tr>
                                                <td>Adyar Departmental Stores</td>
                                                <td></td>
                                                <td></td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>3062965</td>
                                                <td>3003978</td>
                                                <td>0</td>
                                                <td>0</td>
                                                <td>50000</td>
                                                <td>50000</td>
                                            </tr>
                                            <tr>
                                                <td>Arvind Lifestyle Brands Ltd</td>
                                                <td></td>
                                                <td></td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>3062965</td>
                                                <td>3003978</td>
                                                <td>0</td>
                                                <td>0</td>
                                                <td>50000</td>
                                                <td>50000</td>
                                            </tr>
                                            <tr>
                                                <td>Aakash Educational Services</td>
                                                <td></td>
                                                <td></td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>3062965</td>
                                                <td>3003978</td>
                                                <td>0</td>
                                                <td>0</td>
                                                <td>50000</td>
                                                <td>50000</td>
                                            </tr>
                                            <tr>
                                                <td>Aditya Birla Retail Limited</td>
                                                <td></td>
                                                <td></td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>3062965</td>
                                                <td>3003978</td>
                                                <td>0</td>
                                                <td>0</td>
                                                <td>50000</td>
                                                <td>50000</td>
                                            </tr>
                                            <tr>
                                                <td>Adyar Departmental Stores</td>
                                                <td></td>
                                                <td></td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>3062965</td>
                                                <td>3003978</td>
                                                <td>0</td>
                                                <td>0</td>
                                                <td>50000</td>
                                                <td>50000</td>
                                            </tr>
                                            <tr>
                                                <td>Arvind Lifestyle Brands Ltd</td>
                                                <td></td>
                                                <td></td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>3062965</td>
                                                <td>3003978</td>
                                                <td>0</td>
                                                <td>0</td>
                                                <td>50000</td>
                                                <td>50000</td>
                                            </tr>
                                            <tr>
                                                <td>Aakash Educational Services</td>
                                                <td></td>
                                                <td></td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>3062965</td>
                                                <td>3003978</td>
                                                <td>0</td>
                                                <td>0</td>
                                                <td>50000</td>
                                                <td>50000</td>
                                            </tr>
                                            <tr>
                                                <td>Aditya Birla Retail Limited</td>
                                                <td></td>
                                                <td></td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>3062965</td>
                                                <td>3003978</td>
                                                <td>0</td>
                                                <td>0</td>
                                                <td>50000</td>
                                                <td>50000</td>
                                            </tr>
                                            <tr>
                                                <td>Adyar Departmental Stores</td>
                                                <td></td>
                                                <td></td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>3062965</td>
                                                <td>3003978</td>
                                                <td>0</td>
                                                <td>0</td>
                                                <td>50000</td>
                                                <td>50000</td>
                                            </tr>
                                            <tr>
                                                <td>Arvind Lifestyle Brands Ltd</td>
                                                <td></td>
                                                <td></td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>3062965</td>
                                                <td>3003978</td>
                                                <td>0</td>
                                                <td>0</td>
                                                <td>50000</td>
                                                <td>50000</td>
                                            </tr>
                                            <tr>
                                                <td>Aakash Educational Services</td>
                                                <td></td>
                                                <td></td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>3062965</td>
                                                <td>3003978</td>
                                                <td>0</td>
                                                <td>0</td>
                                                <td>50000</td>
                                                <td>50000</td>
                                            </tr>
                                            <tr>
                                                <td>Aditya Birla Retail Limited</td>
                                                <td></td>
                                                <td></td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>3062965</td>
                                                <td>3003978</td>
                                                <td>0</td>
                                                <td>0</td>
                                                <td>50000</td>
                                                <td>50000</td>
                                            </tr>
                                            <tr>
                                                <td>Adyar Departmental Stores</td>
                                                <td></td>
                                                <td></td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>95</td>
                                                <td>88</td>
                                                <td>3062965</td>
                                                <td>3003978</td>
                                                <td>0</td>
                                                <td>0</td>
                                                <td>50000</td>
                                                <td>50000</td>
                                            </tr>
                                            </tbody>
                                        </Table>
                                    </Tab.Pane>


                                </Tab.Content>
                            </div>
                        </Tab.Container>

                    </div>
                </div>
            </div>


        );

    }


}

export default AcqurierDashboard;